/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/statistics.scss';
import Tab from '../../component/Inc/Tab';
import LineChart from '../../component/Inc/LineChart';
import Calendar from '../../component/Inc/Calendar';
import _PopPrice from './_PopPrice';

const SalesBook = () => {
  const navigate = useNavigate();
  const lineChartWidth = '100%';
  const lineChartHeight = '150px';

  const [modalOpen, setModalOpen] = useState(false);
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  //Tab Component
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '총판별', value: 0},
    {title: '도서별', value: 1}
  ];

  //Linechartlabels
  const lineChartlabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  //SalesBook data by Distributor
  const lineChartDataDistributor = {
    lineChartlabels,
    datasets: [
      {
        label: '발송',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '반품',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      }
    ]
  };
  return (
    <main className="com_container p_salesBook">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu10_9 ">총판 매출 통계</h2>
          <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">
            총판 관리
          </button>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />

              <section className="com_board_search">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>

            <hr className="com_divider" />
            <Calendar />

            {/* SalesBook  by distributor */}
            {tabIdx === 0 && (
              <div className="distributor_wrapper">
                <table className="com_board_list ">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                    <col width="{{ width: 'calc(100% / 12)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>NO</th>
                      <th>                        
                        총판명
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        발송 권 수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        발송 금액
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        반품 권 수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        반품 금액
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>실 매출액</th>
                      <th>입금액</th>
                      <th>잔액</th>
                      <th>조정 금액</th>
                      <th>현 잔액</th>
                      <th>상세 보기</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>서울 제일총판</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td className="td_point">450,000</td>
                      <td>450,000</td>
                      <td>450,000</td>
                      <td className="td_point td_width">
                        +40,000
                        <button className="btn_edit" />
                      </td>
                      <td>450,000</td>
                      <td>
                        <button onClick={() => navigate('/Statistics/SalesBook/Detail')} className="btn_link blue">
                          보기
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>서울 제일총판</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td className="td_point">450,000</td>
                      <td>450,000</td>
                      <td>450,000</td>
                      <td className="td_red td_width">
                        -560,000
                        <button className="btn_edit" />
                      </td>
                      <td>450,000</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>서울 제일총판</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td className="td_point">450,000</td>
                      <td>450,000</td>
                      <td>450,000</td>
                      <td className="td_point td_width">
                        +40,000
                        <button className="btn_edit" />
                      </td>
                      <td>450,000</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>서울 제일총판</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td className="td_point">450,000</td>
                      <td>450,000</td>
                      <td>450,000</td>
                      <td className="td_point td_width">
                        +40,000
                        <button className="btn_edit" />
                      </td>
                      <td>450,000</td>
                      <td className="td_point btn_link">보기</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>서울 제일총판</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td className="td_point">450,000</td>
                      <td>450,000</td>
                      <td>450,000</td>
                      <td className="td_point td_width">
                        +40,000
                        <button className="btn_edit" />
                      </td>
                      <td>450,000</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>서울 제일총판</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td className="td_point">450,000</td>
                      <td>450,000</td>
                      <td>450,000</td>
                      <td className="td_point td_width">
                        +40,000
                        <button className="btn_edit" />
                      </td>
                      <td>450,000</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2023</td>
                      <td className="td_point">3,150,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point"></td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2022</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td></td>
                    </tr>

                    <tr className="summarized_rows">
                      <td colSpan="2">증감율</td>
                      <td className="td_red">
                        <span className="arrow_blue">3214</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                <hr className="com_divider" />
                <div className="com_calendar_wrap">
                  <div className="year ">
                    <button className="btn btn_first"></button>
                    <button className="btn btn_prev"></button>
                    <button className="btn_txt">2023</button>
                    <button className="btn btn_next"></button>
                    <button className="btn btn_last"></button>
                  </div>
                </div>
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_labels">
                      <div className="detail_tit dot">경기도 총판</div>
                      <div className="chart_name">
                        <div className="chart_item">
                          <span className="chart_name_label">발송</span>
                          <div className="chart_slider chart_orange"></div>
                        </div>
                        <div className="chart_item">
                          <span className="chart_name_label">반품</span>
                          <div className="chart_slider chart_blue"></div>
                        </div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataDistributor} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* SalesBook  by book */}
            {tabIdx === 1 && (
              <>
                <hr className="com_divider" />
                <div className="btn_wrap">
                  <button className="com_btn black s">조회</button>
                  <button className="com_btn lightGray s">수능</button>
                  <button className="com_btn lightGray s">내신</button>
                </div>
                <hr className="com_divider" />
                <div className="btn_wrap">
                  <button className="com_btn black s">전체</button>
                  <button className="com_btn lightGray s">국어</button>
                  <button className="com_btn lightGray s">영어</button>
                  <button className="com_btn lightGray s">수학</button>
                  <button className="com_btn lightGray s">사탐</button>
                  <button className="com_btn lightGray s">과탐</button>
                  <button className="com_btn lightGray s">논술</button>
                  <button className="com_btn lightGray s">면접</button>
                  <button className="com_btn lightGray s">생디</button>
                </div>
                <hr className="com_divider" />
                <div className="check">
                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                  <label htmlFor="chk01">전체</label>
                  <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                  <label htmlFor="chk02">공식집</label>
                  <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                  <label htmlFor="chk03">개념끝장</label>
                  <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                  <label htmlFor="chk04">내신유형서</label>
                  <input type="checkbox" name="chk" id="chk05" className="com_chk" />
                  <label htmlFor="chk05">한권</label>
                  <input type="checkbox" name="chk" id="chk06" className="com_chk" />
                  <label htmlFor="chk06">이지웨이</label>
                  <input type="checkbox" name="chk" id="chk07" className="com_chk" />
                  <label htmlFor="chk07">기출리허설</label>
                  <input type="checkbox" name="chk" id="chk08" className="com_chk" />
                  <label htmlFor="chk08">모의고사</label>
                  <input type="checkbox" name="chk" id="chk09" className="com_chk" />
                  <label htmlFor="chk09">시크릿</label>
                </div>
                <table className="com_board_list ">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 10)' }}" />
                    <col width="{{ width: 'calc(100% / 10)' }}" />
                    <col width="{{ width: 'calc(100% / 10)' }}" />
                    <col width="{{ width: 'calc(100% / 10)' }}" />
                    <col width="{{ width: 'calc(100% / 10)' }}" />
                    <col width="{{ width: 'calc(100% / 10)' }}" />
                    <col width="{{ width: 'calc(100% / 10)' }}" />
                    <col width="{{ width: 'calc(100% / 10)' }}" />
                    <col width="{{ width: 'calc(100% / 10)' }}" />
                    <col width="{{ width: 'calc(100% / 10)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>NO</th>
                      <th>도서코드</th>
                      <th>과목</th>
                      <th>도서명</th>
                      <th>
                        총 발송 권 수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        총 발송 금액
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        반품 권 수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />                        
                      </th>
                      <th>
                        총 반품 금액
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>실 매출액</th>
                      <th>상세 보기</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>645487</td>
                      <td>수학</td>
                      <td>과탐과학중2</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td>450,000</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>645487</td>
                      <td>영어</td>
                      <td>과탐과학중2</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td>450,000</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>645487</td>
                      <td>수학</td>
                      <td>과탐과학중2</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td>450,000</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>645487</td>
                      <td>수학</td>
                      <td>과탐과학중2</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td>450,000</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>645487</td>
                      <td>수학</td>
                      <td>과탐과학중2</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td>450,000</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>645487</td>
                      <td>수학</td>
                      <td>과탐과학중2</td>
                      <td>45</td>
                      <td className="td_point">78,450,000</td>
                      <td>20</td>
                      <td className="td_red">-350,000</td>
                      <td>450,000</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2023</td>
                      <td></td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point">547,000</td>
                      <td className="td_point"></td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2022</td>
                      <td></td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>
                      <td>547,000</td>

                      <td></td>
                    </tr>

                    <tr className="summarized_rows">
                      <td colSpan="2">증감율</td>
                      <td></td>
                      <td className="td_red">
                        <span className="arrow_blue ">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                <div className="com_btn_wrap right">
                  <button className="com_btn black xs btn_down_orange">다운로드</button>
                </div>
              </>
            )}
          </div>
        </section>
      </div>
      <_PopPrice open={modalOpen} close={() => setModalOpen(false)} />
    </main>
  );
};

export default SalesBook;
